import { DashboardUserType } from '../enums';

export type Session = AdminSession | SellerSession;

export type AdminSession = {
  type: DashboardUserType.ADMIN;
  apiV2Token: string;
  name: string;
  roles: string[];
};

export type SellerSession = {
  type: DashboardUserType.SELLER;
  apiV2Token: string;
  name: string;
  businessName: string;
  businessId: string;
};

export enum ADMIN_ROLES {
  DISBURSEMENT_MANAGMENT = 'disbursement_management',
}

export function adminHasRole(session: AdminSession, role: ADMIN_ROLES) {
  return session.roles.some((item) => item === role);
}
